import React, { useState, useEffect } from 'react';
import api from '../services/api';
import { STORAGE_URL } from '../services/api';
import { Building2, ArrowRight } from 'lucide-react';
import { stats } from '../mock/mockData'; 
import companyVideo from "../assets/company-video.mp4";

const CompaniesAndVideo = () => {
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        const response = await api.get("/top-companies");
        setCompanies(Array.isArray(response.data) ? response.data : []);
      } catch (error) {
        console.error("Error fetching top companies:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchCompanies();
  }, []);

  // 👇 NAYA LOGIC: Sirf active companies ko filter kiya (status == 1) 👇
  const activeCompanies = companies.filter(company => company.status == 1 || company.status === '1');

  return (
    <section className="py-14 bg-gray-50 dark:bg-gray-900 transition-colors duration-300">
      <div className="max-w-[1200px] mx-auto px-4 grid lg:grid-cols-3 gap-6">
        
        {/* Top Companies */}
        <div className="lg:col-span-2 bg-white dark:bg-gray-800 border border-gray-100 dark:border-gray-700 shadow-sm p-6 transition-colors duration-300">
          <div className="flex items-center justify-between mb-5">
            <h3 className="text-lg font-bold text-gray-900 dark:text-white flex items-center gap-2">
              <Building2 className="w-5 h-5 text-[#FED547]" />
              Top Companies Hiring
            </h3>

            <a
              href="#"
              className="text-sm text-[#FED547] font-medium hover:underline flex items-center gap-1"
            >
              View All
              <ArrowRight className="w-3.5 h-3.5" />
            </a>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {loading ? (
              <p className="text-gray-500 col-span-4 text-center py-6">Loading companies...</p>
            ) : activeCompanies.length > 0 ? (
              // 👇 YAHAN AB 'activeCompanies' USE HO RAHA HAI 👇
              activeCompanies.map((company) => (
                <div
                  key={company.id}
                  className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl p-4 flex items-center justify-center hover:shadow-lg transition-all duration-300 h-[100px]"
                >
                  <img
                    src={STORAGE_URL(company.logo)}
                    alt={company.name}
                    className="max-w-full max-h-full object-contain"
                  />
                </div>
              ))
            ) : (
              <p className="text-gray-500 col-span-4 text-center py-6">No active companies found.</p>
            )}
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mt-8 pt-6 border-t border-gray-100 dark:border-gray-700">
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-extrabold text-[#000000] dark:text-white">{stats.Happy_Clients}</div>
              <div className="text-xs text-gray-500 dark:text-gray-300 mt-1">Happy Clients</div>
            </div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-extrabold text-[#000000] dark:text-white">{stats.Placements}</div>
              <div className="text-xs text-gray-500 dark:text-gray-300 mt-1">Placements</div>
            </div>
            <div className="text-center col-span-2 md:col-span-1">
              <div className="text-2xl md:text-3xl font-extrabold text-[#000000] dark:text-white">{stats.Client_Satisfaction}</div>
              <div className="text-xs text-gray-500 dark:text-gray-300 mt-1">Client Satisfaction</div>
            </div>
          </div>
        </div>

        {/* Employer CTA + Video */}
        <div className="flex flex-col gap-6">
          <div
            className="rounded-2xl p-6 text-white shadow-md relative overflow-hidden flex flex-col justify-between min-h-[220px]"
            style={{ background: 'linear-gradient(135deg, #FED547 0%, #eea91fff 100%)' }}
          >
            <div className="absolute -right-6 -bottom-6 w-32 h-32 rounded-full bg-white/10 pointer-events-none" />
            
            <div className="relative z-10">
              <div className="text-[#ffffffff] text-xs font-semibold uppercase tracking-widest">Are you an employer?</div>
              <div className="text-[#ffffffff] font-extrabold text-xl mt-1">Hire In 30 Mins</div>
              <p className="text-[#ffffffff] text-sm mt-2 leading-relaxed">
                Post your requirement and get connected to verified candidates instantly.
              </p>
            </div>
            
            <a
              href="#"
              className="relative z-10 mt-auto inline-block self-start bg-white text-[#000000] font-bold text-sm px-6 py-2.5 rounded-md hover:shadow-lg transition-shadow"
            >
              Post Free Job
            </a>
          </div>

          <div className="rounded-2xl bg-white dark:bg-gray-800 border border-gray-100 dark:border-gray-700 shadow-sm p-4 transition-colors duration-300">
            <h4 className="text-sm font-bold text-gray-900 dark:text-white mb-3">Why Kadtech HR?</h4>
            <video
              className="w-full aspect-video rounded-lg object-cover"
              controls
              preload="metadata"
            >
              <source src={companyVideo} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <div className="text-xs text-gray-600 dark:text-gray-300 mt-2 px-1">
              One place for entry level &amp; blue collar hiring
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CompaniesAndVideo;